import {select, take, call} from 'redux-saga/effects';
import {efServiceAssignmentTypes, BusinessContactDetails} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as samaActionTypes from '../samaActionTypes';
import config from '../../config';

const selectSAMAServiceProviderFlow = function* selectSAMAServiceProviderFlow() {
    const {serviceManager} = yield select(state => state.application);
    const arcGISMapService = !config.IS_FALLBACK_SYSTEM
        ? serviceManager.loadService('arcGISMapService') : null;

    while (true) {
        const {payload} = yield take(samaActionTypes.SUBMIT_SAMA_SERVICE_PROVIDER_FORM);
        const {serviceAssignmentLineNo, serviceCaseId, doctorLocation, serviceProvider} = payload;
        const arcGISMap = !config.IS_FALLBACK_SYSTEM
            ? yield call(arcGISMapService.getMap, 'service-assignment-medical-advice')
            : null;
        const samaDoctorsLayer = arcGISMap ? yield call(arcGISMap.getLayer, 'sama-doctors-layer') : null;
        const samaServiceProvidersLayer = arcGISMap ? yield call(arcGISMap.getLayer, 'sama-service-providers-layer') : null;

        if ((!doctorLocation && !serviceProvider)
            || (!config.IS_FALLBACK_SYSTEM
                && (!arcGISMap || !samaDoctorsLayer))) continue;

        if (!config.IS_FALLBACK_SYSTEM) {
            if (doctorLocation) {
                yield call(samaDoctorsLayer.selectFeatureByAttribute, {
                    where: `locationId = '${doctorLocation.id}'`,
                });
            }

            if (serviceProvider) {
                yield call(samaServiceProvidersLayer.selectFeatureByAttribute, {
                    where: `locationId = '${serviceProvider.arcGISData.locationId}'`,
                });
            }
        }

        yield* updateServiceAssignment({
            caller: 'SELECT_SAMA_SERVICE_PROVIDER_LOCATION',
            assignmentType: efServiceAssignmentTypes.MEDICAL_ADVICE,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData: {
                acePartner: {
                    ...(serviceProvider
                        ? {
                            id: null,
                            externalId: serviceProvider.id,
                            location: {
                                ...serviceProvider.location,
                                ...serviceProvider.address,
                                ...(serviceProvider.arcGISData && {id: serviceProvider.arcGISData.locationId}),
                            },
                            name: serviceProvider.name || '',
                            businessContactDetails: serviceProvider.businessContactDetails,
                        }
                        : {
                            id: null, // see https://computerrock.atlassian.net/browse/ACELEA-575
                            externalId: doctorLocation.id,
                            location: {
                                ...doctorLocation,
                                locationId: doctorLocation.id,
                            },
                            name: doctorLocation.locationName || '',
                            businessContactDetails: new BusinessContactDetails({
                                phoneNo: doctorLocation.phoneNo || '',
                            }),
                        }),
                },
            },
        });
    }
};

export default selectSAMAServiceProviderFlow;
